import axios from '@/libs/axios'

export default {
  updateMyPassword: data => axios.patch('/user/me/change-password', data),
  updateMyProfile: data => axios.patch('/user/me', data),
  getMyOrganizationCustomer: organizationId => axios.get(`/user/me/organizations/${organizationId}/customer`),
  getMyOrganizationCustomers: organizationId => axios.get(`/user/me/organizations/${organizationId}/customers`),
}
